// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAebtc } from "../../../icons/mono/build/icon-aebtc.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AebtcIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAebtc.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AebtcIcon.displayName = 'AebtcIcon';
}

export default AebtcIcon;